(function () {
  var overlay = document.getElementById("wearthOverlayDrawer");
  if (!overlay) return;

  var MOBILE = window.matchMedia("(max-width: 989px)");
  var legacyDetails = document.getElementById("Details-menu-drawer-container");
  var scrollY = 0;
  var openedAt = 0;
  var backdropGuardMs = 450;

  function isMobile() {
    return MOBILE.matches;
  }

  function clearLegacyDrawerState() {
    if (!legacyDetails) return;
    legacyDetails.removeAttribute("open");
    legacyDetails.classList.remove("menu-opening");
    document.body.classList.remove(
      "overflow-hidden-tablet",
      "overflow-hidden-mobile",
      "overflow-hidden",
      "menu-drawer-open"
    );
  }

  function lockBody() {
    scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.setProperty("top", "-" + scrollY + "px");
    document.body.classList.add("wearth-overlay-locked");
  }

  function unlockBody() {
    document.body.classList.remove("wearth-overlay-locked");
    document.body.style.removeProperty("top");
    window.scrollTo(0, scrollY);
  }

  function openDrawer() {
    clearLegacyDrawerState();
    overlay.setAttribute("data-state", "open");
    overlay.setAttribute("aria-hidden", "false");
    lockBody();
    openedAt = Date.now();
    document.dispatchEvent(new CustomEvent("wearth:overlay-open"));
  }

  function closeDrawer() {
    overlay.setAttribute("data-state", "closed");
    overlay.setAttribute("aria-hidden", "true");
    unlockBody();
    clearLegacyDrawerState();
    document.dispatchEvent(new CustomEvent("wearth:overlay-close"));
  }

  function isOpen() {
    return overlay.getAttribute("data-state") === "open";
  }

  function bindHamburger() {
    if (!legacyDetails) return;
    var summary = legacyDetails.querySelector("summary");
    if (!summary || summary.dataset.wearthOverlayBound === "1") return;
    summary.dataset.wearthOverlayBound = "1";

    summary.addEventListener(
      "click",
      function (e) {
        if (!isMobile()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        if (isOpen()) {
          closeDrawer();
        } else {
          openDrawer();
        }
      },
      true
    );
  }

  if (legacyDetails) {
    legacyDetails.addEventListener("toggle", function () {
      if (!isMobile()) return;
      if (legacyDetails.hasAttribute("open")) {
        legacyDetails.removeAttribute("open");
        if (!isOpen()) openDrawer();
      }
    });
  }

  overlay.addEventListener("click", function (e) {
    if (!e.target.closest("[data-wearth-overlay-close]")) return;
    if (Date.now() - openedAt < backdropGuardMs) return;
    e.preventDefault();
    closeDrawer();
  });

  overlay.addEventListener(
    "touchend",
    function (e) {
      if (!e.target.closest("[data-wearth-overlay-close]")) return;
      if (Date.now() - openedAt < backdropGuardMs) {
        e.preventDefault();
      }
    },
    { passive: false }
  );

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && isOpen()) closeDrawer();
  });

  document.addEventListener("shopify:section:load", function () {
    bindHamburger();
    if (isOpen()) {
      clearLegacyDrawerState();
      lockBody();
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindHamburger);
  } else {
    bindHamburger();
  }
})();
